import { defineEvent } from "@visioni/a3s-analytics";

/** `previous_tenant_id` is absent for a first choice. */
export type TenantSelectedProps = {
  tenant_id: string;
  previous_tenant_id: string | undefined;
  tenant_count: number;
};

export const TenantSelected = defineEvent<TenantSelectedProps>("Tenant Selected");

/** `undefined` when the tenant is already selected or isn't one of the user's. */
export function tenantSelectedProps(
  tenants: readonly { id: string }[],
  currentId: string | undefined,
  nextId: string,
): TenantSelectedProps | undefined {
  if (nextId === currentId || !tenants.some((t) => t.id === nextId)) return undefined;
  return { tenant_id: nextId, previous_tenant_id: currentId, tenant_count: tenants.length };
}
